import { formatCPF } from '@brazilian-utils/brazilian-utils';
import { formatCashValue } from './cashProduct';

export const TransactionType = {
    expiration: 'expiration',
    adition: 'adition',
    refuel: 'refuel',
    redemption: 'redemption',
    refund: 'refund',
};

const TYPE_LABEL = {
    [TransactionType.expiration]: 'Expiração',
    [TransactionType.adition]: 'Adição',
    [TransactionType.refuel]: 'Abastecimento',
    [TransactionType.redemption]: 'Resgate',
    [TransactionType.refund]: 'Estorno',
};

/**
 * Rótulo da coluna Produto.
 *
 * Testa o produto ANTES da flag de propósito: o produto em dinheiro vem com
 * `isCashback = true` E `productId` preenchido, então checar a flag primeiro
 * rotularia o vale como "Cashback". O cashback de valor livre é o único que
 * tem a flag sem produto.
 */
export const productLabelOf = (row) => {
    if (!row || !row.isCoupon) { return null; }

    if (row.product) {
        return row.product.isCash ? formatCashValue(row.product) : (row.product.name || null);
    }

    return row.isCashback ? 'Cashback' : null;
};

/**
 * Linhas do extrato a partir das transações e dos cupons.
 *
 * Os cupons chegam de um request separado (`GET /coupons?filter={transactionIds}`)
 * porque `GET .../transactions` não os embute: os joins `transaction.coupons` e
 * `coupon.product` foram removidos do backend por custo de CPU (fan-out de linhas
 * quebrando a paginação). É o mesmo caminho que o pontuax-admin usa.
 *
 * Uma transação com cupons vira uma linha POR cupom — um resgate de N unidades
 * gera N cupons, cada um com seu barcode e seu botão de reimpressão. Transação
 * sem cupom aparece como ela mesma.
 */
export const buildStatementRows = (transactions, coupons, customerName) => {
    if (!Array.isArray(transactions)) { return []; }

    const couponsByTransaction = (Array.isArray(coupons) ? coupons : []).reduce((map, coupon) => {
        const key = coupon.transactionId;
        if (!key) { return map; }
        if (!map[key]) { map[key] = []; }
        map[key].push(coupon);
        return map;
    }, {});

    return transactions.reduce((rows, transaction) => {
        const typeString = TYPE_LABEL[transaction.type] || '';
        const transactionCoupons = couponsByTransaction[transaction.id] || [];

        if (transactionCoupons.length === 0) {
            return [...rows, { ...transaction, typeString, isCoupon: false }];
        }

        return [...rows, ...transactionCoupons.map(coupon => ({
            ...coupon,
            isCoupon: true,
            typeString,
            type: transaction.type,
            place: coupon.place || transaction.place,
            customer: transaction.customerCpf ? formatCPF(transaction.customerCpf) : undefined,
            customerName,
        }))];
    }, []);
};
